export default (theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        borderTop: `1px solid ${theme.colors.grey[100]}`,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    listContainer: { width: '100%', height: '100%', padding: '16px', paddingTop: '0px' },
    list: {},
    iconDisabled: {
        opacity: 0.5,
        cursor: 'not-allowed',
    },
    divider: {
        borderBottom: `1px solid ${theme.colors.grey[100]}`,
    },
});
